import React from 'react';
import { useHistory } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';
import data65 from '../../data/data65.json'
import ArticleList from '../../Components/ArticleList';

const Constitution: React.FC = () => {
    const history = useHistory();

    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>章程制度</h1>
                <ArticleList dataId="65" data={data65 as any} />
            </div>
        } />
    );
};

export default Constitution;